import { isEmptyObject } from '../validators/formValidators';
import glp from 'google-libphonenumber';

// TODO - do not change this method. SMS lookup is dependent on it. If you do, normalize
// client->Phone format / storage first
export const normalizePhone = (value, previousValue = '') => {
    if (isEmptyObject(value)) {
        return value;
    }

    let number = '';
    try {
        let phoneUtil = glp.PhoneNumberUtil.getInstance();
        let formatter = new glp.AsYouTypeFormatter('US');
        formatter.clear();
        let valueCopy = value.replace(/\D/g, '');
        for (let i = 0; i < valueCopy.length; i++) {
            number = formatter.inputDigit(valueCopy.charAt(i));
        }

    } catch (error) {
        console.error(new Error().stack, error);
        number = value;
    }

    return number;
};

export const normalizeSSN = (value, previousValue) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d]/g, '');
    if (!previousValue || value.length > previousValue.length) {
        // typing forward
        if (onlyNums.length === 3) {
            return onlyNums + '-';
        }

        if (onlyNums.length === 4) {
            return onlyNums;
        }

        if (onlyNums.length === 5) {
            return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3) + '-';
        }
    }

    if (onlyNums.length <= 4) {
        return onlyNums;
    }

    if (onlyNums.length < 5) {
        return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
    }

    return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 5) + '-' + onlyNums.slice(5, 9);
};

export const normalizeExpiry = (value, previousValue) => {
    if (!value) {
        return value;
    }

    let onlyNums = value.replace(/[^\d]/g, '');
    onlyNums = onlyNums.substr(0, 4);
    if (onlyNums.length === 2 && previousValue[previousValue.length - 1] !== '/') {
        onlyNums += '/'; 
    } else if (onlyNums.length > 2) {
        onlyNums = onlyNums[0] + onlyNums[1] + '/' + onlyNums.substr(2);
    }

    return onlyNums;
};

export const normalizeMoney = (value, previousValue) => {
    if (!value) {
        return value;
    }

    const onlyNums = value.replace(/[^\d,.]/g, '');
    return onlyNums;
};